<template>
  <div class="file-preview">
    <!-- 图片缩略图 -->
    <img
        v-if="previewType === 'image'"
        :src="finalUrl"
        class="thumb-img preview-border"
        @click="handleClick"
    />

    <!-- PDF 缩略图 -->
    <div
        v-else-if="previewType === 'pdf'"
        class="thumb-box preview-border"
        @click="handleClick"
    >
      <a-icon type="file-pdf" class="pdf-icon" />
      <div class="thumb-text">PDF</div>
    </div>

    <!-- 下载 -->
    <div
        v-else
        class="thumb-box download-border"
        @click="handleDownload"
    >
      <a-icon type="download" class="download-icon" />
      <div class="thumb-text">下载</div>
    </div>

    <!-- 图片预览 Modal -->
    <a-modal
        :visible="imgVisible"
        :footer="null"
        @cancel="imgVisible = false"
        width="60%"
    >
      <img :src="finalUrl" style="width: 100%" />
    </a-modal>
  </div>
</template>

<script>


export default {
  name: 'FilePreview',
  props: {
    fileNo: {
      type: String,
      default: ''
    },
    fileUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      finalUrl: '',
      previewType: '',
      imgVisible: false
    }
  },
  async mounted() {
    this.finalUrl = await this.getFinalUrl()
    this.previewType = this.calcPreviewType(this.finalUrl)
  },
  methods: {
    async getFinalUrl() {
      // 优先使用 fileUrl
      if (this.fileUrl) return this.fileUrl

      // 如果有 fileNo，就调接口
      if (this.fileNo) {
        try {
          const res = await this.api.getFullUrl(this.fileNo)
          return res?.data || ''
        } catch (err) {
          console.error('获取完整地址失败:', err)
          return ''
        }
      }

      return ''
    },

    handleClick() {
      if (!this.finalUrl) return

      if (this.previewType === 'image') {
        this.imgVisible = true
      } else if (this.previewType === 'pdf') {
        window.open(this.finalUrl)
      } else {
        this.handleDownload()
      }
    },

    handleDownload() {
      if (!this.finalUrl) return
      const link = document.createElement('a')
      link.href = this.finalUrl
      link.target = '_blank'
      link.download = `template.${this.getFileExtension(this.finalUrl)}`
      link.click()
    },

    calcPreviewType(url) {
      const ext = this.getFileExtension(url)
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) return 'image'
      if (ext === 'pdf') return 'pdf'
      return 'download'
    },

    getFileExtension(url) {
      if (!url) return ''
      return url.split('?')[0].split('.').pop().toLowerCase()
    }
  }
}
</script>

<style scoped>
.file-preview {
  display: inline-block;
}

.thumb-img,
.thumb-box {
  width: 72px;
  height: 72px;
  cursor: pointer;
  border-radius: 4px;
}

.thumb-img {
  object-fit: cover;
}

.thumb-box {
  text-align: center;
  padding-top: 12px;
}

.preview-border {
  border: 2px solid #1890ff;
}

.download-border {
  border: 2px dashed #d9d9d9;
}

.pdf-icon {
  font-size: 30px;
  color: #ff4d4f;
}

.download-icon {
  font-size: 26px;
}

.thumb-text {
  font-size: 12px;
  margin-top: 6px;
}
</style>
